import { GridTable } from '~/components/GridTable';

import { getRowStats } from '../utils';

const columnLabels = ['', 'STARTER', 'PLACERING', 'SEGER-%', 'ROI'];

const Trainer = ({ stats, betType }) => (
  <GridTable
    title="TRÄNARE"
    labels={columnLabels}
    alignColumnTitlesRight
    gridTemplateColumns="3fr repeat(4, max-content)"
    data={[
      getRowStats(stats.last_year, 'Senaste året'),
      getRowStats(stats.last_month, 'Senaste månaden'),
      // Show only V75 stats
      ...(betType === 'V75' ? [getRowStats(stats[betType], betType)] : []),
    ]}
  />
);

export default Trainer;
